import styled from 'styled-components'

export const FooterContainer = styled.footer`
  background: #101522;
  padding: clamp(40px, 6vw, 60px) 20px;

  /* espaço para a barra fixa de compra e o botão do WhatsApp no celular */
  @media (max-width: 768px) {
    padding-bottom: 110px;
  }
`

export const FooterGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 1.2fr 1fr;
  gap: 30px;
  align-items: flex-start;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    /* aviso ocupa a linha inteira */
    & > div:nth-child(3) {
      grid-column: 1 / -1;
      order: 5;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 28px;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 600px) {
    align-items: center;
  }
`

export const LogoImg = styled.img`
  width: 100%;
  max-width: 190px;
  height: auto;
  margin-top: 4px;

  @media (max-width: 600px) {
    max-width: 170px;
  }
`

export const TrackButton = styled.a`
  background: #1E8BB8;
  color: #fff;
  padding: 14px 22px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  text-align: center;

  &:hover {
    opacity: 0.85;
  }
`

export const ColumnTitle = styled.h4`
  color: #fff;
  margin-bottom: 6px;
`

export const AvisoText = styled.p`
  color: #ccc;
  font-size: 14px;
  line-height: 1.4;
`

export const PaymentImg = styled.img`
  max-width: 180px;
`

export const SecureButton = styled.div`
  background: #e0e0e0;
  color: #555;
  padding: 10px 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
`